import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

export type TUser = {
  branch: string;
  email: string;
  firstName: string;
  lastName: string;
  imageUrl: string;
  role: 'SUPER_ADMIN' | 'ADMIN' | 'USER';
  status: string;
  _id: string;
  personType: string;
  mfaEnabled?: boolean;
  mfaCohort?: string | null;
};

const useHook = () => {
  return useQuery('users', async () => {
    const response = await service.get('/users');
    return response.data.users as TUser[];
  });
};

export default useHook;
